import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgReplyAll = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-348.44 -348.44 2488.89 2488.89",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "matrix(1 0 0 -1 0 1536)",
		d: "M640 454V384Q640 342 601 325Q588 320 576 320Q549 320 531 339L19 851Q0 870 0.0 896.0Q0 922 19 941L531 1453Q560 1484 601 1467Q640 1450 640 1408V1339L243 941Q224 922 224.0 896.0Q224 870 243 851ZM1792 416Q1792 358 1775.0 282.5Q1758 207 1736.5 144.5Q1715 82 1688.5 19.5Q1662 -43 1648.0 -71.0Q1634 -99 1628 -111Q1620 -128 1600 -128Q1594 -128 1591 -127Q1566 -119 1568 -93Q1611 307 1462 472Q1398 543 1291.5 582.5Q1185 622 1024 635V384Q1024 342 985 325Q972 320 960 320Q933 320 915 339L403 851Q384 870 384.0 896.0Q384 922 403 941L915 1453Q944 1484 985 1467Q1024 1450 1024 1408V1146Q1435 1118 1623 925Q1792 752 1792 416Z"
	})
});
export default SvgReplyAll;
